<template>
	<v-hover>
        <v-card flat title  class="mb-4 mx-2 hero-ba-ads pointer" slot-scope="{ hover }" :class="`elevation-${hover ? 5 : 0}`"  v-ripple @click="route(item.id)">
            <v-img
                class="white--text grey"
                aspect-ratio="1.45"
                :src="item.data.images[0].link"
                :lazy-src="item.data.images[0].link"
                >
                <v-container class="pa-0" fill-height fluid>
                    <v-layout column fill-height>
                        <v-flex shrink>
                            <!-- <div style="display: flex">
                                <v-spacer></v-spacer>
                                <v-btn @click="" class="hero-icon-bg" flat color="white" icon>
                                    <v-icon size="25">
                                        {{item.data.favourite ? 'mdi-heart-circle' : 'mdi-heart-circle-outline' }}
                                    </v-icon>
                                </v-btn>
                            </div> -->
                            <div v-if="placeLock" style="display: flex">
                                <v-spacer></v-spacer>
                                <v-btn class="hero-icon-bg" flat color="white" icon>
                                    <v-icon size="25">
                                        mdi-lock
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex shrink>
                            <div style="display: flex" class="title font-weight-regular price-tag">
                                <span>Price:</span>
                                <v-spacer></v-spacer>
                                <span class="font-weight-medium">&#8358;{{Math.abs(item.data.price).toLocaleString('en-US')}}</span>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>

                <template v-slot:placeholder>
                    <v-layout
                    fill-height
                    align-center
                    justify-center
                    ma-0
                    >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                </template>
            </v-img>
            <div v-if="!placeLock">
                <v-card-text class="px-3 py-0">
                  	<div class="title text-capitalize mt-2 text-truncate mb-2 font-weight-medium">{{item.data.lodgeName}}</div>
                	<div class="body-1 mb-2 mr-1 text-truncate"><v-icon size="17">mdi-compass-outline</v-icon> {{item.data.address}} | {{item.data.location}}</div>
                	<span class="text-truncate">
                    	<span class="caption"><v-icon size="17">mdi-home-modern</v-icon> {{ item.data.vacancy}} vacant rooms</span>
                    	 | 
	                	<span class="caption"><v-icon size="16">mdi-diamond-stone</v-icon> {{item.data.features.length}} Features</span>
	            	</span>
                </v-card-text>
	            <v-card-actions class="px-3 py-2">
	                <span class="grey--text caption text-truncate"><v-icon size="15">mdi-eye</v-icon> {{item.data.views}} views</span>
	                <v-spacer></v-spacer>
	                <span class="grey--text caption text-truncate"><v-icon size="15">mdi-clock-check-outline</v-icon> {{timeManager(item.data.updatedOn)}}</span>
	            </v-card-actions>
            </div>

            <div v-else>
                <v-card-text class="px-3 pb-0 pt-0">
                    <div class="title text-capitalize mt-2 text-truncate mb-2 font-weight-medium">{{item.data.lodgeName}}</div>
                    <div class="body-2 mb-2 mr-1">
                        <v-avatar tile size="17px" class="mr-1">
                          <img src="/assets/medal.png">
                        </v-avatar>
                        <span>Sign-up/login to gain full access to all our lodge listings...</span>
                    </div>
                </v-card-text>
                <v-card-actions class="px-3 py-2">
                    <span class="grey--text caption text-truncate"><v-icon size="15">mdi-eye</v-icon> {{item.data.views}} views</span>
                    <v-spacer></v-spacer>
                    <span class="grey--text caption text-truncate"><v-icon size="15">mdi-clock-check-outline</v-icon> {{timeManager(item.data.updatedOn)}}</span>
                </v-card-actions>
            </div>
        </v-card>
    </v-hover>
</template>

<script>
	export default {
	    props: {
	    	item: {
	    		type: Object,
	    		default: () => {
	    			return {}
	    		}
	    	},
            lock: {
                type: Boolean,
                default: () => {
                    return false
                }
            }
	    },
	    methods: {
	    	timeManager(timeStamp) {
	            var options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
	            var currentDate = new Date().toLocaleDateString("en-US", options)
	            var date = new Date(timeStamp).toLocaleDateString("en-US", options)
	            var time = new Date(timeStamp).toLocaleTimeString("en-US")

	            if (currentDate == date) {
	                return time
	            } else {
	                return date
	            }

	        },
            route(arg) {
                if (this.placeLock) {
                    this.$store.state.dialogPay = true
                } else {
                    this.$router.push('/lodge/'+arg)
                }
            }
	    },
        computed: {
            placeLock() {
                if (this.lock && this.$store.state.userData == null) {
                    return true
                }
                
                return false
            }
        }
	};
</script>

<style scoped>
	.price-tag {
		padding: 5px;
		background: rgba(0,0,0,0.6);
	}
</style>